// extracted by mini-css-extract-plugin
export default {"event-edit-popup":"EventEditPopup_event-edit-popup__j+TqG","project-type-wrapper":"EventEditPopup_project-type-wrapper__0fCK+"};